// extracted by mini-css-extract-plugin
module.exports = {"unfocused":"focus__unfocused___gdawe","focused":"focus__focused___1uFyv"};